<template>
  <article class="help-article">
    <header class="help-article__header">
      <div class="help-article__eyebrow">Taleem help</div>
      <h1>{{ topic.title }}</h1>
      <p>{{ topic.summary }}</p>
    </header>

    <section v-for="section in topic.sections" :key="section.title" class="help-article__section">
      <h2>{{ section.title }}</h2>
      <p v-for="paragraph in section.body || []" :key="paragraph">{{ paragraph }}</p>
      <ul v-if="section.bullets && section.bullets.length">
        <li v-for="bullet in section.bullets" :key="bullet">{{ bullet }}</li>
      </ul>
      <ol v-if="section.steps && section.steps.length">
        <li v-for="step in section.steps" :key="step">{{ step }}</li>
      </ol>
      <v-alert v-if="section.note" type="warning" text dense class="help-article__note">
        {{ section.note }}
      </v-alert>
    </section>

    <section v-if="relatedTopics.length" class="help-article__section">
      <h2>Related help</h2>
      <div class="help-article__related">
        <v-btn
          v-for="related in relatedTopics"
          :key="related.id"
          small
          outlined
          color="primary"
          @click="$emit('select-topic', related.id)"
        >
          {{ related.title }}
        </v-btn>
      </div>
    </section>
  </article>
</template>

<script>
import { getHelpTopic } from "@/modules/Help/helpTopics"

export default {
  name: "help-article",
  props: {
    topic: { type: Object, required: true },
  },
  computed: {
    relatedTopics() {
      return (this.topic.related || []).map(getHelpTopic).filter(topic => topic.id !== "overview")
    },
  },
}
</script>

<style scoped>
.help-article { color: #26332a; }
.help-article__header { padding-bottom: 20px; border-bottom: 1px solid #e5ebe6; }
.help-article__eyebrow { margin-bottom: 5px; color: #2e7d32; font-size: 11px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }
.help-article h1 { margin: 0 0 8px; font-size: 25px; font-weight: 600; line-height: 1.25; }
.help-article__header p { margin: 0; color: #667269; font-size: 14px; line-height: 1.6; }
.help-article__section { padding: 20px 0; border-bottom: 1px solid #edf1ed; }
.help-article__section:last-child { border-bottom: 0; }
.help-article h2 { margin: 0 0 10px; font-size: 16px; font-weight: 600; }
.help-article p, .help-article li { color: #465149; font-size: 14px; line-height: 1.65; }
.help-article p { margin: 0 0 9px; }
.help-article ul, .help-article ol { margin: 0; padding-left: 22px; }
.help-article li + li { margin-top: 6px; }
.help-article__note { margin: 14px 0 0; font-size: 13px; }
.help-article__related { display: flex; flex-wrap: wrap; gap: 8px; }
</style>

